import { render } from "./BaseCard.vue?vue&type=template&id=50a00549&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=50a00549&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a00549"]])

export default __exports__